import PropTypes from 'prop-types';
import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Stack, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { FormProvider, RHFTextField } from '../../../components/hook-form';

import { declineReturnRequest } from '../store/maintenanceActions';

DeclineReturn.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  maintenanceId: PropTypes.string,
};

export default function DeclineReturn({ open, handleClose, maintenanceId }) {
  const dispatch = useDispatch();

  const DeclineReturnSchema = Yup.object().shape({
    rejectionReason: Yup.string().required('Rejection Reason is required'),
  });

  const defaultValues = {
    rejectionReason: '',
  };

  const methods = useForm({
    resolver: yupResolver(DeclineReturnSchema),
    defaultValues,
  });

  const {
    // reset,
    // watch,
    // control,
    // setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const values = {
      rejection_reasons: data.rejectionReason,
    };
    const payload = {
      id: maintenanceId,
      payload: values,
    };
    const result = await dispatch(declineReturnRequest(payload));
    if (result?.ok) handleClose(true);
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      fullWidth
      keepMounted
      onClose={() => handleClose(false)}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Return Decline Form</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Stack spacing={2}>
            <RHFTextField multiline row="3" name="rejectionReason" label="Rejection Reason" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="error" onClick={() => handleClose(false)}>
            Cancel
          </Button>
          <LoadingButton type="submit" size="small" variant="contained" loading={isSubmitting}>
            Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
